import React, { ReactElement } from "react";
import Select from "../../select/Select";
import Timezones from "./timezones.json";

interface Props<TRequired extends boolean> {
    onChange: (value: TRequired extends true ? string : (string | undefined)) => void;
    isRequired?: TRequired;
    value?: TRequired extends true ? string : (string | undefined);
    placeholder?: string;
    className?: string;
}

export default function TimezoneSelect<TRequired extends boolean>({
    onChange: onSelected, isRequired, value, placeholder, className,
}: Props<TRequired>): ReactElement {
    return (
        <Select
            className={className}
            minRequired={isRequired ? 1 : 0}
            placeholder={placeholder}
            onChange={option => onSelected(option?.value)}
            options={Timezones.map(timezone => ({
                label: timezone,
                value: timezone,
            }))}
            value={value ? {
                label: value,
                value,
            } : undefined}
        />
    );
}
TimezoneSelect.defaultProps = {
    isRequired: false,
    value: undefined,
    placeholder: undefined,
    className: "",
};
